import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../components';
import { useStore } from '../../../../store';
import Product from '../../store/Product';

export default observer(function DuplicateButton({
  product,
}: {
  product: Product;
}) {
  const navigate = useNavigate();
  const { productStore } = useStore();

  async function onClick() {
    const newProduct = await productStore.duplicateProduct(product.id);
    navigate(`/products/${newProduct.id}`);
  }

  if (product.isNew) {
    return null;
  }

  return (
    <Button icon="copy" onClick={onClick} type="secondary">
      Duplicate
    </Button>
  );
});
